import * as api from '../api';
// import { CHECK_IF_EMAIL_EXIST } from '../constants/action-types';

export const checkIfEmail = (email, setCheckEmail) => dispatch => {
  api.checkIfEmailExist(email, setCheckEmail).then(emailExist => {
      // dispatch(receiveIfEmailExist(emailExist));
      return emailExist;
  })
}

// export const receiveIfEmailExist = emailExist => ({
//   type: CHECK_IF_EMAIL_EXIST,
//   emailExist
// });